import * as React from "react";
const SVGComponent = (props) => (
    <svg
        width={21}
        height={23}
        viewBox="0 0 21 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#clip0_986_26037)">
            <path
                d="M15.8281 8.4707C15.8281 7.14462 15.3013 5.87285 14.3637 4.93517C13.426 3.99749 12.1542 3.4707 10.8281 3.4707C9.50204 3.4707 8.23027 3.99749 7.29259 4.93517C6.35491 5.87285 5.82812 7.14462 5.82812 8.4707C5.82812 14.304 3.32812 15.9707 3.32812 15.9707H18.3281C18.3281 15.9707 15.8281 14.304 15.8281 8.4707Z"
                stroke="black"
                strokeWidth={1.66667}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.2661 19.3047C12.1196 19.5573 11.9093 19.7669 11.6563 19.9126C11.4033 20.0584 11.1165 20.1351 10.8245 20.1351C10.5325 20.1351 10.2456 20.0584 9.99262 19.9126C9.73961 19.7669 9.52932 19.5573 9.38281 19.3047"
                stroke="black"
                strokeWidth={1.66667}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx={15.3906} cy={5.41406} r={4.5} fill="#E80F0F" stroke="white" />
        </g>
        <defs>
            <clipPath id="clip0_986_26037">
                <rect
                    width={20}
                    height={22}
                    fill="white"
                    transform="translate(0.546875 0.046875)"
                />
            </clipPath>
        </defs>
    </svg>
);
export default SVGComponent;
